import 'babel-polyfill'
import 'url-search-params-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import promise from 'es6-promise'
import VueClipboard from 'vue-clipboard2';
promise.polyfill()
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.use(VueClipboard);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
